import React ,{ useRef } from 'react';
import { 
    Show,
    SimpleShowLayout,
    CardActions,
    ListButton
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import ReactToPrint from "react-to-print";
import PrintIcon from '@material-ui/icons/Print';
import SampleModes from './SampleModes'

const useStyles = makeStyles({
   
    root: { 
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800',            
        alignItems: 'middle'
    },

    title: {
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '90%',
        maxWidth: '800',
        alignItems: 'middle',
        border: 'double',
        fontSize: '14',
        fontWeight: 'bold'
    },

    printButton: {
        backgroundColor: '#3f51b5',
        "&:hover": {
            backgroundColor: 'navy'
        },
        textAlign: 'center', 
        verticallAign: 'middle',
        borderRadius: '10px',
        color: 'white',
        fontWeight: 'bold',
        float: 'left',
        width: '6em',
       
    }
})

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};
const BoxActions = ({basePath}) => (
    <CardActions style={cardActionStyle}>
        <ListButton  
        label='Box List' 
        basePath={basePath}
        />
    </CardActions>
);


const Print = ({record}) => {
    const componentRef = useRef();
    const classes = useStyles();
    return (
      <div>
            <SampleModes record={record}  ref={componentRef} />
            <ReactToPrint
            trigger={() => <button className={classes.printButton} > {<PrintIcon />} </button>}
            content={() => componentRef.current}
            />
      </div>
    );
  };


const BoxView= ({ classes, ...props }) => (
    <Show
    {...props}
    /* disable the app title change when shown */
    title="Sample Box View "
    actions={<BoxActions />}
    >
    <SimpleShowLayout>
        <Print />
    </SimpleShowLayout>
</Show>
)

export default BoxView